export default {
  allVerificationQuestions(state) {
    return state.verificationQuestions;
  },
  selectedVerificationQuestion(state) {
    return state.VerificationQuestion;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/verification_questions/getters.js